//Reset data
export const RESET = "NOTIFICATION_UPDATE_RESET"

export const SET_IS_UPDATED = "NOTIFICATION_UPDATE_SET_IS_CREATE"
export const SET_NOT_UPDATED = "NOTIFICATION_UPDATE_SET_NOT_CREATE"
//Loading
export const SET_TOGGLE_LOADING = "NOTIFICATION_UPDATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "NOTIFICATION_UPDATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "NOTIFICATION_UPDATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "NOTIFICATION_UPDATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "NOTIFICATION_UPDATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "NOTIFICATION_UPDATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "NOTIFICATION_UPDATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "NOTIFICATION_UPDATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "NOTIFICATION_UPDATE_SET_HIDE_MESSAGE"

//Data
export const SET_UPDATE = "NOTIFICATION_UPDATE_SET_UPDATE"
export const SET_CURRENT_ITEM = "NOTIFICATION_UPDATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "NOTIFICATION_UPDATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "NOTIFICATION_UPDATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "NOTIFICATION_UPDATE_SET_HIDE_MODAL"


export const SET_MODAL = "NOTIFICATION_UPDATE_SET_MODAL"
export const SET_MODAL_CONTENT = "NOTIFICATION_UPDATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "NOTIFICATION_UPDATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "NOTIFICATION_UPDATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "NOTIFICATION_UPDATE_SET_MODAL_TYPE"